(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronadela-home"] && !Shopify.designMode) return;
  try {
    
(() => {
  const hero = document.querySelector('[data-rd-hero-slider]');
  if (hero) {
    const slides = Array.from(hero.querySelectorAll('.rd-hero__slide'));
    const dots = Array.from(hero.querySelectorAll('.rd-hero__dots button'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let heroTimer = 0;

    const showSlide = (index) => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === current;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === current;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const stopHero = () => {
      if (heroTimer) window.clearInterval(heroTimer);
      heroTimer = 0;
    };
    const startHero = () => {
      stopHero();
      if (!reducedMotion.matches && slides.length > 1) {
        heroTimer = window.setInterval(() => showSlide(current + 1), 5000);
      }
    };

    dots.forEach((dot, index) => dot.addEventListener('click', () => {
      showSlide(index);
      startHero();
    }));
    hero.addEventListener('mouseenter', stopHero);
    hero.addEventListener('mouseleave', startHero);
    hero.addEventListener('focusin', stopHero);
    hero.addEventListener('focusout', startHero);
    window.addEventListener('pagehide', stopHero, { once: true });
    showSlide(0);
    startHero();
  }

  const cards = Array.from(document.querySelectorAll('.rd-product'));
  if (!cards.length) return;

  cards.forEach((card) => {
    const photo = card.querySelector('.rd-product__photo');
    if (!photo) return;
    const markLoaded = () => photo.classList.add('is-loaded');
    if (photo.complete && photo.naturalWidth > 0) markLoaded();
    else {
      photo.addEventListener('load', markLoaded, { once: true });
      photo.addEventListener('error', () => photo.remove(), { once: true });
    }
  });

  const touchLayout = window.matchMedia('(hover: none), (pointer: coarse)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!touchLayout.matches || reducedMotion.matches || !('IntersectionObserver' in window)) return;

  const visible = new Set();
  const completed = new WeakSet();
  let activeCard = null;
  let timer = 0;
  let frame = 0;

  const chooseClosest = () => {
    frame = 0;
    if (activeCard) return;

    const center = window.innerHeight / 2;
    const candidates = Array.from(visible)
      .filter((card) => !completed.has(card))
      .filter((card) => card.querySelector('.rd-product__photo.is-loaded'))
      .map((card) => {
        const rect = card.getBoundingClientRect();
        return { card, distance: Math.abs(rect.top + rect.height / 2 - center) };
      })
      .filter((item) => item.distance <= window.innerHeight * 0.32)
      .sort((a, b) => a.distance - b.distance);

    if (!candidates.length) return;

    activeCard = candidates[0].card;
    completed.add(activeCard);
    activeCard.classList.add('is-photo-peek');

    timer = window.setTimeout(() => {
      activeCard?.classList.remove('is-photo-peek');
      visible.delete(activeCard);
      activeCard = null;
      timer = 0;
      if (visible.size && !frame) frame = window.requestAnimationFrame(chooseClosest);
    }, 1500);
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(chooseClosest);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) visible.add(entry.target);
      else visible.delete(entry.target);
    });
    schedule();
  }, { threshold: [0.35, 0.55, 0.75] });

  cards.forEach((card) => {
    observer.observe(card);
    const photo = card.querySelector('.rd-product__photo');
    photo?.addEventListener('load', schedule, { once: true });
  });

  window.addEventListener('pagehide', () => {
    if (timer) window.clearTimeout(timer);
    if (frame) window.cancelAnimationFrame(frame);
    observer.disconnect();
  }, { once: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ronadela-phone-grip"] && !Shopify.designMode) return;
  try {
    
function initGripSections(){document.querySelectorAll('[data-grip-section]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-grip-image]').forEach(button=>button.addEventListener('click',()=>{const main=root.querySelector('.rd-grip__main');if(!main)return;main.removeAttribute('srcset');main.removeAttribute('sizes');main.src=button.dataset.gripImage;main.alt=button.dataset.gripAlt;root.querySelectorAll('[data-grip-image]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));}));});}
initGripSections();document.addEventListener('shopify:section:load',initGripSections);

  } catch(e) { console.error(e); }
})();
})();
